import React from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  return <section className="pricing" id="comprar" data-id="element-111">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-112">
        <span className="section-tag" style={{
        color: 'var(--ember)'
      }} data-id="element-113">
          Acceso Inmediato
        </span>
        <h2 data-id="element-114">Aprende una habilidad que vale miles de dólares.</h2>
        <p className="comparison-line" data-id="element-115">
          Diseñador: $2K–$5K · Agencia: $5K–$15K · Este workshop:
        </p>

        <div className="price-card" data-id="element-116">
          <div className="price-old" data-id="element-117">$87 USD</div>
          <div className="price-amount" data-id="element-118">
            <span className="dollar" data-id="element-119">$</span>37
          </div>
          <div className="price-detail" data-id="element-120">
            PAGO ÚNICO · ACCESO DE POR VIDA · TEMPLATE INCLUIDO
          </div>
          <a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="cta-btn" data-id="element-121">
            QUIERO APRENDER AHORA
          </a>
        </div>
      </motion.div>
    </section>;
}